import React from "react";
import {
  Input,
  Button,
  Row,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import SearchableDropdown from "./AuthorUIComponents/SearchableDropdown";

import DeleteButton from "./AuthorUIComponents/DeleteButton";
import LessonCard from "./LessonCard";
export default class LessonData extends React.Component {
  state = {
    displayName: "Apostrophes",
    name: "apostrophesEdit",
    lessonParent: "Challenger",
    lessonStatus: true,
    nodes: [
      { lessonId: "01", name: "abc" },
      { lessonId: "01", name: "sdf" },
      { lessonId: "01", name: "sdsf" }
    ]
  };
  showDelete(node) {
    this.setState({ [node.name]: true });
  }
  hideDelete(node) {
    if (!this.state[`${node.name}-clicked`]) {
      this.setState({ [node.name]: false });
    }
  }
  handleClickAway(node) {
    this.setState({
      [`${node.name}-clicked`]: false,
      [node.name]: false
    });
  }
  render() {
    return (
      <React.Fragment>
          <LessonCard
            iconClass="info-lesson"
            heading="Lesson Data"
            isCollapsable={true}
          >
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Lesson Display name: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  value={this.state.displayName}
                  onChange={e => {
                    this.setState({
                      displayName: e.target.value,
                      displayNameChanged: true
                    });
                  }}
                  onFocus={e => {
                    //console.log(e.target.value)
                    //this.setState({ displayNameChanged: true })
                  }}
                />
                {this.state.displayNameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ displayNameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Lesson Internal name: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  value={this.state.name}
                  onChange={e =>
                    this.setState({ name: e.target.value, nameChanged: true })
                  }
                />
                {this.state.nameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ nameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Lesson Parent: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>{this.state.lessonParent}</span>
                <span
                  className="modal-link"
                  onClick={() => this.setState({ showModalParent: true })}
                >
                  Change Parent
                </span>
              </Col>
            </Row>

            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Lesson Status: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>
                  {this.state.lessonStatus ? "Published" : "Unpublished"}
                </span>
                <span
                  className="modal-link"
                  onClick={() => this.setState({ showModalPublish: true })}
                >
                  {this.state.lessonStatus ? "Unpublish" : "Publish"}
                </span>
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Nodes: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                {this.state.nodes.map(node => (
                  <div>
                    <div
                      className="node-name"
                      onMouseEnter={() => this.showDelete(node)}
                      onMouseLeave={() => this.hideDelete(node)}
                    >
                      {node.name}{" "}
                      {
                        <label
                          className={`delete-parent${
                            this.state[`${node.name}`] ? "-active" : ""
                          }`}
                          onClick={() =>
                            this.setState({ [`${node.name}-clicked`]: true })
                          }
                          onBlur={() => this.handleClickAway(node)}
                        >
                          <DeleteButton
                            handleDelete={() => console.log("Delete Node")}
                            index={node.name}
                          />
                        </label>
                      }
                    </div>
                  </div>
                ))}
                <div className="node-btn">
                  <Button
                    className="lesson-action-btn"
                    onClick={() => this.props.editNode(true)}
                  >
                    Edit Node
                  </Button>
                </div>
              </Col>
            </Row>
          </LessonCard>
        <Modal isOpen={this.state.showModalParent} className={"modal-card"}>
          <ModalHeader className="modal-header">Change Parent</ModalHeader>
          <ModalBody>
            <div>
              The record name record collectionName is currently in this . Move
              it to a different collection
            </div>

            <Label>Subcourse: </Label>

            <div>
              <SearchableDropdown
                value={this.state.selectedSubcourse}
                placeholder={"Select Subcourse"}
              >
                {[
                  "subcourse 1",
                  "subcourse 2",
                  "subcourse 3",
                  "subcourse 4",
                  "subcourse 5",
                  "subcourse 6",
                  "subcourse 7"
                ].map(subcourse => {
                  return (
                    <Row  onClick={() =>
                      this.setState({ selectedSubcourse: subcourse })
                    }>
                      <label
                       
                      >
                        {subcourse}
                      </label>
                      <hr />
                    </Row>
                  );
                })}
              </SearchableDropdown>
            </div>
            <Label>Sections: </Label>

            <div>
              <SearchableDropdown
                value={this.state.selectedSection}
                isDisabled={!this.state.selectedSubcourse}
                placeholder={"Select Subcourse"}
              >
                {[
                  "section 1",
                  "section 2",
                  "section 3",
                  "section 4",
                  "section 5",
                  "section 6",
                  "section 7"
                ].map(section => {
                  return (
                    <Row
                      onClick={() =>
                        this.setState({ selectedSection: section })
                      }
                    >
                      <label>{section}</label>
                      <hr />
                    </Row>
                  );
                })}
              </SearchableDropdown>
            </div>
          </ModalBody>
          <ModalFooter className="modal-footer">
            <hr className="bottom-line" />
            <Button
              onClick={() => this.setState({ showModalParent: false })}
              className="cancle"
            >
              Cancel
            </Button>
            <Button
              disabled={
                !this.state.selectedSubcourse && !this.state.selectedSection
              }
              onClick={() => this.setState({ showModalParent: false })}
              className={`action${(!!this.state.selectedSubcourse &&
                !!this.state.selectedSection &&
                "-active") ||
                ""}`}
            >
              Move
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.showModalPublish} className={"modal-card"}>
          <ModalHeader className="modal-header">Publish Lesson</ModalHeader>
          <ModalBody>
            <p>
            Please confirm yuou would like to UNPUBLISH the <b>ApostrophesEdit (Apostrophes) Lesson</b>. Once unpublished, the record.collectionName will no longer be accessible as part of the course.
            <br />
            Unpublishing does not delete data.
            </p>
          </ModalBody>
          <ModalFooter className="modal-footer">
            
          <Button
              onClick={() => this.setState({ showModalPublish: false })}
              className="cancle"
            >
              Cancel
            </Button>
            <Button
              onClick={() => this.setState({ showModalPublish: false })}
              className="action-active"
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/LessonData.js